/* --------------------------------------------------------------------------------------
   xwSlider.directive.js
   Copyright © 2021 Xerox Corporation. All Rights Reserved.

   Copyright protection claimed includes all forms and matters of copyrightable material
   and information now allowed by statutory or judicial law or hereinafter granted,
   including without limitation, material generated from the software programs which
   are displayed on the screen such as icons, screen display looks, etc.
   -------------------------------------------------------------------------------------
*/

/*eslint semi: ["error", "never"]*/
export class xwSlider {
  /*@ngInject*/
  constructor (appSettings) {
    this.restrict = 'A'
    this.appSettings = appSettings
    this.scope = {
      customChannel: '<',
      customFeedbackLabels: '<',
      rangeLabels: '<',
      min: '<',
      max: '<',
      showTicks: '<',
      widgetSize: '<',
      initialValue: '<',
      onSlide: '&',
    }
  }
  link(scope, elem, attrs) {
    let init = false
    const element = elem.first()
    setTimeout(() => {
      element.xrxslider(this.getOptions(attrs, scope))
      init = true
    })
  }
  getOptions(attrs, scope) {
    return {
      customChannel: scope.customChannel,
      customFeedbackLabels: scope.customFeedbackLabels,
      rangeLabels: scope.rangeLabels,
      max: scope.max,
      min: scope.min,
      showTicks: scope.showTicks,
      widgetSize: scope.widgetSize,
      initialValue: scope.initialValue,
      slide: (event, ui) => scope.onSlide(),
    };
  }
  static directiveFactory(appSettings) {
    xwSlider.instance = new xwSlider(appSettings)
    return xwSlider.instance
  }
}



// WEBPACK FOOTER //
// ./src/app/xrxWrappers/xwSlider.directive.js